import type { Key } from 'react';

export const JsonLd = ({ data, key }: { data: object; key?: Key | null }) => (
  <script
    key={key}
    type="application/ld+json"
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
  />
);

export const createMetaTags = ({
  description,
  title,
  ogImage,
}: {
  title: string;
  description?: string;
  ogImage?: string;
}) => (
  <>
    <title>{title}</title>
    <meta key="og:title" property="og:title" content={title} />
    {description && (
      <meta key="description" name="description" content={description} />
    )}
    {description && (
      <meta
        key="og:description"
        property="og:description"
        content={description}
      />
    )}
    {ogImage && <meta key="og:image" property="og:image" content={ogImage} />}
  </>
);
